export const Monitor = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 30V24" stroke="currentColor" stroke-width="2"/>
<path d="M19 30V24" stroke="currentColor" stroke-width="2"/>
<path d="M8 30H24" stroke="currentColor" stroke-width="2"/>
<rect x="3" y="6" width="26" height="18" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
